import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { useDispatch } from 'react-redux';
import Header from '../Header/Header';
import Sidebar from '../Sidebar/Sidebar';
import Loader from '../Loader/Loader';
import {
  LayoutContainer,
  LoaderContainer,
  MainContainer,
} from './Style/Layout.style';
import { useAuth0 } from '../../__mocks__/@auth0/auth0-react';
import { useCurrentUserQuery } from '../../queries/user';
import { showToast } from '../../store/toaster/action';

const DefaultLayout = ({ children }: any) => {
  const [open, setOpen] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const { isAuthenticated, getIdTokenClaims, user } = useAuth0();
  const dispatch = useDispatch();
  const handleDrawerClose = () => {
    setOpen(false);
  };
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  useEffect(() => {
    const getToken = async () => {
      const token: any = await getIdTokenClaims();
      setIsLoading(false);
      window.localStorage.setItem('userToken', token?.__raw);
      window.localStorage.setItem('authUserSub', JSON.stringify(user));
    };
    if (isAuthenticated) {
      getToken();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getIdTokenClaims, isAuthenticated]);

  // Bootstrap the internal user record: the query is enabled only once the
  // Auth0 token has been written to localStorage (the apiClient reads it),
  // and every other consumer of useCurrentUserQuery dedupes onto this fetch.
  const { isError: userIsError } = useCurrentUserQuery(
    isAuthenticated && !isLoading,
  );

  useEffect(() => {
    if (userIsError) {
      dispatch(showToast('Failed to load user session', 'error'));
    }
  }, [userIsError, dispatch]);

  return (
    <Box sx={LayoutContainer}>
      {isAuthenticated && !isLoading ? (
        <>
          <Header open={open} />
          <Sidebar
            open={open}
            handleDrawerClose={handleDrawerClose}
            handleDrawerOpen={handleDrawerOpen}
          />
          <MainContainer>{children}</MainContainer>
        </>
      ) : (
        <LoaderContainer>
          <Loader size={30} />
        </LoaderContainer>
      )}
    </Box>
  );
};

export default DefaultLayout;
